import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./PageFooter.module.scss";

export const PageFooter = ({ className }: PlatformComponentProps) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PageFooter");

  return (
    <div className={clsx(block, className)}>
      <span className={cn("copyright")}>{`© ${new Date().getFullYear()} ${t(
        "footerCopyRight"
      )}`}</span>
    </div>
  );
};
